import React, { useEffect } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import { Dispatch } from 'redux';
import MemberApplicationsListContainer from './appContainer/MemberApplicationsListContainer';
import {
    configs,
    endpoints,
    environmentSelector,
    fetchAppControllerInfo,
    useAppDispatch,
    useAppSelector,
    SideNavContainer,
    PAGE_TYPE,
} from '../utils';

const capApplications = () => {
    const {
        routes: { GET_CAP_APPLICATIONS },
    } = configs;
    const dispatch: Dispatch<any> = useAppDispatch();
    const environment = useAppSelector(environmentSelector);
    const { id } = useParams();
    const encHouseHoldId = id;

    useEffect(() => {
        dispatch(
            fetchAppControllerInfo(
                endpoints.MEMBER_APP_LIST_CONTROLLER.processReplacements({
                    encHouseHoldId,
                }),
                environment,
            ),
        );
    }, [id, encHouseHoldId]);

    return (
        <SideNavContainer page={PAGE_TYPE.APPLICATION_ELIGIBILITY_PAGE}>
            <Switch>
                <Route path={GET_CAP_APPLICATIONS} exact>
                    <MemberApplicationsListContainer />
                </Route>
            </Switch>
        </SideNavContainer>
    );
};

export default capApplications;
